// extracted by mini-css-extract-plugin
module.exports = {"cls1":"NavbarButton-module--cls1--wVKbN","cls2":"NavbarButton-module--cls2--1f1Fe NavbarButton-module--cls1--wVKbN"};